import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Seo from "@/components/Seo";
import { PageHero } from "@/pages/About";
import { CtaBand } from "@/pages/Home";
import { Reveal } from "@/components/Reveal";
import { useLanguage } from "@/context/LanguageContext";
import { neighborhoods } from "@/data/neighborhoods";

export default function Neighborhoods() {
  const { lang, t } = useLanguage();
  return (
    <main data-testid="neighborhoods-page">
      <Seo
        title="Miami Neighborhoods Guide — Carlos Vindel Realty"
        siteName="Carlos Vindel Realty"
        description="Explore Coral Gables, Brickell, Coconut Grove, Doral, Kendall, and Miami Beach with a local South Florida real estate expert."
      />
      <PageHero testid="neighborhoods-hero" overline={t.neighborhoodsPage.overline} title={t.neighborhoodsPage.title} subtitle={t.neighborhoodsPage.subtitle} />

      <section className="bg-cream py-20 sm:py-28">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 grid grid-cols-1 md:grid-cols-2 gap-8">
          {neighborhoods.map((n, i) => (
            <Reveal key={n.slug} delay={(i % 2) * 0.1}>
              <Link
                to={`/neighborhoods/${n.slug}`}
                data-testid={`neighborhood-page-card-${n.slug}`}
                className="group block bg-white border border-sand/80 overflow-hidden shadow-[0_2px_24px_rgba(13,19,26,0.05)] hover:shadow-[0_16px_48px_rgba(13,19,26,0.12)] transition-shadow duration-500"
              >
                <div className="relative aspect-[16/9] overflow-hidden">
                  <img
                    src={n.image}
                    alt={`${n.name}, South Florida`}
                    loading="lazy"
                    className="w-full h-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-108"
                  />
                  <span className="absolute top-4 left-4 bg-cream/90 backdrop-blur text-ink text-[10px] uppercase tracking-[0.2em] font-semibold px-3 py-1.5">
                    {t.neighborhoodsPage.median} · {n.median}
                  </span>
                </div>
                <div className="p-7">
                  <p className="text-[10px] uppercase tracking-[0.25em] text-gold-dark font-semibold">{n.tagline[lang]}</p>
                  <h2 className="mt-2 font-serif text-3xl text-ink">{n.name}</h2>
                  <p className="mt-3 text-[#525D6B] text-sm leading-relaxed line-clamp-2">{n.description[lang]}</p>
                  <span className="mt-5 inline-flex items-center gap-2 text-sm font-semibold text-ink link-underline-gold">
                    {t.neighborhoodsPage.readMore}
                    <ArrowRight className="w-4 h-4 text-gold transition-transform duration-300 group-hover:translate-x-1" />
                  </span>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </section>

      <CtaBand />
    </main>
  );
}
